/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-04-25 16:06:37
 * @LastEditTime : 2023-07-14 10:45:37
 * @LastEditors  : yangxr
 * @Description  :
 * @FilePath     : \icps_fb\src\api\smart\schedul\gpsDevice.js
 */
import request from "@/utils/request";

/*获取传输数据车辆*/
export function queryCarPositionList(data) {
  return request({
    url: "/posttion/queryCarPositionList",
    method: "post",
    data,
  });
}
/*获取车辆下拉列表*/
export function queryCarNoList(data) {
  return request({
    url: "/posttion/queryCarNoList",
    method: "post",
    data,
  });
}
/*获取站点下拉列表*/
export function queryStationList(data) {
  return request({
    url: "/posttion/queryStationList",
    method: "post",
    data,
  });
}
/*获取车辆维护列表*/
export function queryCarPositionPage(data) {
  return request({
    url: "/posttion/queryCarPositionPage",
    method: "post",
    data,
  });
}
/*添加车辆维护*/
export function saveOrUpdateCars(data) {
  return request({
    url: "/posttion/saveOrUpdateCars",
    method: "post",
    data,
  });
}
/*删除车辆维护*/
export function deleteCars(params) {
  return request({
    url: "/posttion/deleteCars",
    method: "get",
    params,
  });
}
/*站点维护*/
export function stationQueryPage(data) {
  return request({
    url: "/icps/system/sign/basics/station/QueryPage",
    method: "post",
    data,
  });
}
